import { useState, useCallback } from 'react';
import Card from '../components/common/Card';
import ImageLightbox from '../components/common/ImageLightbox';
import img01 from '../../assets/dress_code/01.webp';
import img02 from '../../assets/dress_code/02.jpg';
import img03 from '../../assets/dress_code/03.jpg';
import img04 from '../../assets/dress_code/04.jpg';
import img05 from '../../assets/dress_code/05.jpg';
import img06 from '../../assets/dress_code/06.webp';
import img07 from '../../assets/dress_code/07.jpg';
import img08 from '../../assets/dress_code/08.jpg';
import img09 from '../../assets/dress_code/09.jpg';

const dressCodeImages = [img01, img02, img03, img04, img05, img06, img07, img08, img09];

export default function Details() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const handleImageClick = useCallback((index: number) => setLightboxIndex(index), []);
  const handleClose = useCallback(() => setLightboxIndex(null), []);

  return (
    <div className="min-h-screen py-16 bg-gradient-to-br from-pink-light via-cream to-lavender-light">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl md:text-5xl text-center mb-12 text-gray-800">
          Wedding Details
        </h1>

        {/* Date & Time */}
        <Card className="mb-8">
          <h2 className="text-2xl md:text-3xl mb-4 text-pink">Date & Time</h2>
          <div className="text-lg text-gray-700 space-y-2">
            <p><strong>Date:</strong> Saturday, 15th August 2026</p>
            <p><strong>Time:</strong> 3pm</p>
          </div>
        </Card>

        {/* Venue */}
        <Card className="mb-8">
          <h2 className="text-2xl md:text-3xl mb-4 text-pink">Venue</h2>
          <div className="text-lg text-gray-700 space-y-2">
            <p><strong>Location:</strong> Kawana Surf Club</p>
            <p><strong>Address:</strong> 99 Pacific Blvd, Sunshine Coast, QLD 4575</p>
            {/* <p className="text-gray-600 text-sm mt-4">
              [Add directions or parking information]
            </p> */}
          </div>
        </Card>

        {/* Schedule */}
        <Card className="mb-8">
          <h2 className="text-2xl md:text-3xl mb-4 text-pink">Schedule (TBD)</h2>
          <div className="space-y-4 text-gray-700">
            <div className="flex flex-col md:flex-row md:items-start">
              <span className="font-semibold text-lavender-dark md:w-32">3:30 - 4:00pm</span>
              <span>Ceremony</span>
            </div>
            <div className="flex flex-col md:flex-row md:items-start">
              <span className="font-semibold text-lavender-dark md:w-32">4:00 - 5:45pm</span>
              <span>Canapés, Mingling &amp; Photography</span>
            </div>
            <div className="flex flex-col md:flex-row md:items-start">
              <span className="font-semibold text-lavender-dark md:w-32">6:00 - 7:30pm</span>
              <span>Reception &amp; Dinner</span>
            </div>
          </div>
        </Card>

        {/* Dress Code */}
        <Card>
          <h2 className="text-2xl md:text-3xl mb-4 text-pink">Dress Code</h2>
          <p className="text-lg text-gray-700 mb-6">
            Semi-Formal or Cocktail Beach Attire.<br /> We encourage our guests to wear warm earthy hues, soft pastels or rich jewel tones.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {dressCodeImages.map((src, i) => (
              <button
                key={i}
                onClick={() => handleImageClick(i)}
                className="group relative w-full aspect-square rounded-lg overflow-hidden focus:outline-none focus:ring-4 focus:ring-pink-300"
                aria-label={`View dress code inspiration ${i + 1}`}
                type="button"
              >
                <img
                  src={src}
                  alt={`Dress code inspiration ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-200 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 drop-shadow-lg">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    <line x1="11" y1="8" x2="11" y2="14" />
                    <line x1="8" y1="11" x2="14" y2="11" />
                  </svg>
                </div>
              </button>
            ))}
          </div>
        </Card>
      </div>
      {lightboxIndex !== null && (
        <ImageLightbox
          images={dressCodeImages}
          initialIndex={lightboxIndex}
          onClose={handleClose}
        />
      )}
    </div>
  );
}
